__turbopack_context__.v({
  "group": "CoreGroup-module-scss-module__MJ3mnq__group",
});
